import { render } from "./DirectMailSubmit.vue?vue&type=template&id=04027515&scoped=true"
import script from "./DirectMailSubmit.vue?vue&type=script&lang=js"
export * from "./DirectMailSubmit.vue?vue&type=script&lang=js"

import "./DirectMailSubmit.vue?vue&type=style&index=0&id=04027515&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04027515"]])

export default __exports__